<nav class="sidebar">

  <div class="sidebar-top">
    <!-- Logo -->

    @if (isAdmin) {
      <button class="nav-item" title="Admin" (click)="goToAdmin()">
        <ngk-icon icon="settings" size="1.25rem" />
        <span class="nav-label">Admin</span>
      </button>
    }
  </div>

  <!-- Sign out -->
  <button class="nav-item sign-out" title="Sign Out" (click)="logout()">
    <ngk-icon icon="log-out" size="1.25rem" />
    <span class="nav-label">Sign Out</span>
  </button>

</nav>
